import { useServicesContext } from "@modules/core/services/services.context"
import { ExploreContentEntity } from "@modules/explore/entities/exploreEntity"
import { ExploreFilter } from "@modules/explore/exploreTypes"
import { useInfiniteQuery } from "@tanstack/react-query"
import { useMemo, useState } from "react"

export const useExploreSearchContents = (filter: ExploreFilter) => {
  const [searchTerms, setSearchTerms] = useState("")

  const { exploreApi } = useServicesContext()

  const { data, isLoading, refetch, fetchNextPage } = useInfiniteQuery({
    queryKey: ["exploreSearch", searchTerms, filter],
    queryFn: async ({ pageParam }) => {
      return exploreApi.searchExplore(searchTerms, {
        filter: filter === ExploreFilter.DEFAULT ? undefined : filter,
        page: pageParam,
        size: 10,
      })
    },
    staleTime: 1000 * 60 * 5,
    initialPageParam: 0,
    getNextPageParam: (lastPage) => {
      if (lastPage.content.length === 0) {
        return null
      }
      return lastPage.page + 1
    },
  })

  const itemList = useMemo(
    () => data?.pages.flatMap((page) => page.content).map((content) => ExploreContentEntity.fromDto(content)) ?? [],
    [data],
  )

  return {
    data: {
      ...data,
      content: itemList,
      totalSize: data?.pages[0]?.totalSize ?? 0,
    },
    setSearchTerms,
    isLoading,
    refetch,
    fetchNextPage,
  }
}
